// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "microsite_conversation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "microsite_conversation" table (1:1 with a DB row, on the wire). */
export const micrositeConversationAtomSchema = z.object({
    id: z.string(),
    micrositeId: z.string(),
    organizationId: z.string(),
    userId: z.string().nullable(),
    title: z.string().nullable(),
    lastMessageAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=micrositeConversation.js.map